/**
 * @Auther: Qsan
 * @Date：2018年12月12日 17:27
 * @Desc：核心组件统一配置
 */
import MqlTable from './MqlTable'
import SvgIcon from './SvgIcon'
import MqlHeader from './MqlLayout/MqlHeader'
import MqlFilter from './MqlLayout/MqlFilter'
import MqlMain from './MqlLayout/MqlMain'
import MqlDatefilter from './MqlDatefilter'
import MqlFormTitle from './MqlLayout/MqlFormTitle'
import MqlBreadcrumb from './MqlLayout/MqlBreadcrumb'
import MqlBread from './MqlLayout/MqlBread'
import MqlTextradioGroup from './MqlTextradioGroup'
import MqlTextradio from './MqlTextradio'
import MqlDatefilterClone from './MqlDatefilterClone'

const components = [
    MqlTable,
    SvgIcon,
    MqlHeader,
    MqlMain,
    MqlDatefilter,
    MqlFilter,
    MqlFormTitle,
    MqlBreadcrumb,
    MqlBread,
    MqlTextradioGroup,
    MqlTextradio,
    MqlDatefilterClone
]

const install = function (Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })

    Vue.prototype.goBack = () => {
        history.go(-1)
    }
}

export default {
    install
}



// WEBPACK FOOTER //
// ./src/components/core/index.js